export default {
  en: {
    title: 'Refund Policy',
    updated: 'September 11, 2026',
    sections: [
      {
        heading: '1. No Refunds',
        paragraphs: [
          'All payments for SocialLabs subscriptions are final and non-refundable.',
          'By completing a purchase, you acknowledge and agree that you are not entitled to a refund, credit, or prorated amount for any reason, including but not limited to unused time, change of mind, or account cancellation.',
        ],
      },
      {
        heading: '2. Subscriptions & Cancellation',
        paragraphs: [
          'Subscriptions renew automatically each billing period unless cancelled before the renewal date.',
          'When you cancel, you retain access until the end of the current paid period. Cancellation does not entitle you to a refund for the remaining time or any prior billing period.',
        ],
      },
      {
        heading: '3. Billing Errors',
        paragraphs: [
          'If you believe you were charged in error (e.g. duplicate charge), contact contact@codelabs.id within 7 days with your account email and transaction ID. We will review billing errors only, not refund requests for change of mind or dissatisfaction with the Service.',
        ],
      },
      {
        heading: '4. Chargebacks',
        paragraphs: [
          'Initiating a chargeback or payment dispute without first contacting us may result in immediate account suspension.',
          'Unfounded chargebacks may be contested with the payment provider.',
        ],
      },
    ],
  },
  id: {
    title: 'Kebijakan Pengembalian Dana',
    updated: '11 September 2026',
    sections: [
      {
        heading: '1. Tidak Ada Pengembalian Dana',
        paragraphs: [
          'Semua pembayaran untuk langganan SocialLabs bersifat final dan tidak dapat dikembalikan.',
          'Dengan menyelesaikan pembelian, Anda mengakui dan setuju bahwa Anda tidak berhak atas pengembalian dana, kredit, atau jumlah proporsional dengan alasan apa pun, termasuk namun tidak terbatas pada waktu yang tidak terpakai, perubahan pikiran, atau pembatalan akun.',
        ],
      },
      {
        heading: '2. Langganan & Pembatalan',
        paragraphs: [
          'Langganan diperpanjang otomatis setiap periode tagihan kecuali dibatalkan sebelum tanggal perpanjangan.',
          'Saat Anda membatalkan, akses tetap aktif hingga akhir periode berbayar saat ini. Pembatalan tidak memberikan hak pengembalian dana untuk sisa waktu atau periode tagihan sebelumnya.',
        ],
      },
      {
        heading: '3. Kesalahan Penagihan',
        paragraphs: [
          'Jika Anda yakin dikenai biaya karena kesalahan (mis. tagihan duplikat), hubungi contact@codelabs.id dalam 7 hari dengan email akun dan ID transaksi. Kami hanya meninjau kesalahan penagihan, bukan permintaan pengembalian dana karena perubahan pikiran atau ketidakpuasan terhadap Layanan.',
        ],
      },
      {
        heading: '4. Chargeback',
        paragraphs: [
          'Mengajukan chargeback atau sengketa pembayaran tanpa menghubungi kami terlebih dahulu dapat mengakibatkan penangguhan akun segera.',
          'Chargeback tanpa dasar dapat kami tolak melalui penyedia pembayaran.',
        ],
      },
    ],
  },
}
